import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import TextInputField from "../Form/TextInputField";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";

interface Props {
	isMandatory: boolean;
	projectName: string;
}

interface State {
	projectName?: string;
	projectNameDisable: boolean;
	error: { [ k: string ]: string };
}

class ProjectUnitDetails extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		const projectName = props.projectName;
		const isProjectAvailable = !isEmptyStringOrNull( props.projectName );
		this.state = {
			projectName: isProjectAvailable ? projectName : "",
			projectNameDisable: isProjectAvailable,
			error: {},
		};
	}

	render() {
		const { isMandatory } = this.props;
		const { error, projectNameDisable } = this.state;
		return <div className="card" id="ProjectUnitDetails">
			<div className="card-header">
				<span>{ "4 - " + Strings.project_or_unit_details }</span>
			</div>
			<div className="card-body">
				<div className="row">
					<div className="col-md-12">
						<div className="mandatory-field-info">
							<small>{ Strings.mandatory_fields_note }</small>
						</div>
					</div>
					<div className="col-md-6">
						<TextInputField
							id={ "projectName" }
							holder={ this }
							required={ isMandatory }
							label={ Strings.Project_Name_Label }
							error={ error.projectName }
							containerClassName={ "form-group field-style" }
							disabled={ projectNameDisable }/>
					</div>
				</div>
			</div>
		</div>;
	}

	public isValid(): Promise<string> {
		const { isMandatory } = this.props;
		const { projectName } = this.state;
		if ( isMandatory ) {
			let isValid = true;
			const error: { [ k: string ]: string } = {};
			if ( isEmptyStringOrNull( projectName ) ) {
				error.projectName = Strings.required;
				isValid = false;
			}
			this.setState( {
				error: error,
			} );
			if ( isValid ) {
				return Promise.resolve( projectName! );
			}
			return Promise.reject( "DefendantDetails not Valid" );
		} else {
			return Promise.resolve( projectName ? projectName : "" );
		}
	}

	public reset() {
		const projectName = this.props.projectName;
		this.setState( {
			projectName: !isEmptyStringOrNull( projectName ) ? projectName : "",
			error: {},
		} );
	}
}

export default ProjectUnitDetails;
